import React from 'react';
import { Register as SharedRegister } from '@gastrosoft/shared/auth';
import { useBranding } from '../contexts/BrandingContext';
import { authClient } from './authClient';
import { saveReferral } from '@/utils/referral';
import { saveInvitationToken } from '@/utils/invitationToken';

export default function Register() {
  const { logo, appName } = useBranding();

  const handleReferralParams = ({ ref, invite }: { ref?: string; invite?: string }) => {
    if (ref) saveReferral(ref);
    if (invite) saveInvitationToken(invite);
  };

  return (
    <SharedRegister
      appTitle={appName}
      logo={logo}
      authClient={authClient}
      onReferralParams={handleReferralParams}
    />
  );
}
